import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const MaterialcodeExp = () => {

  const detials2 = [
    { label: 'Material Code reference', value: ' ' },
  ]
  
  const device = [
    {
        category: 'Blank Sim',
        items: [
          { materialCode: '20012802', description: 'SIM CARD-UNIVERSAL 5G-GHUDC-HALF SIZE', servicetype: 'POSTPAID/PREPAID' },
          { materialCode: '20015621', description: 'SIM CARD-UNIVERSAL-BLANK SIM-64K 3IN1', servicetype: 'POSTPAID/PREPAID' },
          { materialCode: '20009721', description: 'SIM CARD-POSTPAID-GHUDC-64K USIM 3 IN 1', servicetype: 'POSTPAID' },
          { materialCode: '20012352', description: 'SIM CARD-UNIVERSAL-GHUDC-HALF SIZE', servicetype: 'POSTPAID/PREPAID' },
          { materialCode: '20015387', description: 'SIM CARD-GENERIC-LIGHTNING-64K 3IN1', servicetype: 'PREPAID' },
        ],
      },
      {
        category: 'ESIM',
        items: [
            { materialCode: 'ESIM030001', description: 'SIM CARD-ESIM POST-GHUDC-64K ESIM', servicetype: 'POSTPAID' },
        ],
      },
      {
        category: 'Starterpack',
        items: [
          { materialCode: '20015520', description: 'SPACK-CD PREPAID RM5-5G-BIRU', servicetype: 'PREPAID' },
          { materialCode: '20015622', description: 'SPACK-CD PREPAID RM10 MODENTRADE-5G-BIRU', servicetype: 'PREPAID' },
          { materialCode: '20015519', description: 'SPACK-CD PREPAID RM10-5G-BIRU', servicetype: 'PREPAID' },
          { materialCode: '20013225', description: 'SPACK-CXPAX RM5-CTRL1', servicetype: 'PREPAID' },
          { materialCode: '20013188', description: 'SPACK-CXPAX RM10-CTRL1', servicetype: 'PREPAID' },
          { materialCode: '20011545', description: 'SPACK-XPAX2019 RM30-CTRL1', servicetype: 'PREPAID' },
        ],
      }
  ]

  return (
    <>
      <TableContainer component={Paper}>
            <Table>
              <TableBody>
                {detials2.map((row) => (
                  <TableRow key={row.label}>
                    <TableCell component="th" scope="row">{row.label}</TableCell>
                    <TableCell colSpan={4}>{row.value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
      </TableContainer>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Category</TableCell>
              <TableCell>Material Code</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Service Type</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {device.map((category) => (
            <React.Fragment key={category.category}>
              {category.items.map((item, index) => (
                <TableRow key={`${category.category}-${item.materialCode}`}>
                  {index === 0 && (
                    <TableCell rowSpan={category.items.length}>
                      {category.category}
                    </TableCell>
                  )}
                  <TableCell>{item.materialCode}</TableCell>
                  <TableCell>{item.description}</TableCell>
                  <TableCell>{item.servicetype}</TableCell>
                </TableRow>
              ))}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </>
  );
};

export default MaterialcodeExp;